import { Link } from '@tanstack/router'
import { useMemo, useState } from 'react'

import useGameCategories from '../../hooks/useGameCategories'
import { useBoundStore } from '../../store/store'
import Icon from '../icon'

type CasinoDrawerTabsProps = {
  closeProfileDrawer: () => void
}

const CasinoDrawerTabs = ({ closeProfileDrawer }: CasinoDrawerTabsProps) => {
  const { categories: casinoCategories } = useGameCategories()
  const username = useBoundStore(state => state.user.username)
  const [isOpen, setIsOpen] = useState(false)

  const categories = useMemo(
    () => (username ? casinoCategories : casinoCategories.slice(0, -1)),
    [username],
  )

  return (
    <div
      className="transition-all duration-[0.2s] ease-[ease-in-out] overflow-hidden border-b-[#f5f6f9] dark:border-b-[#1f223c] border-b border-solid"
      style={{
        height: isOpen ? categories.length * 40 + 51 : '39px',
      }}>
      <div
        className="flx-btw-ctr px-5 py-2.5"
        onClick={() => setIsOpen(prev => (prev ? false : true))}>
        <div className="flx-str-ctr">
          <p className="text-highlight uppercase mx-2.5">CASINO</p>
        </div>
        <Icon
          id="triangle-down"
          className="transition-all duration-[0.2s] ease-[ease-in-out]"
          width="16"
          height="10"
          fill="#46aef7"
          style={{ transform: `rotate(${isOpen ? '-180' : '0'}deg)` }}
        />
      </div>
      <div className="bg-secondary pl-5 pr-0 py-1.5">
        {categories.map(category => (
          <Link
            to="/casino/$category"
            params={{
              category: category.category.toLowerCase().replace(' ', '-'),
            }}
            key={category.id}>
            <div
              className="flx-str-ctr px-0 py-2 last:border-[none]"
              onClick={closeProfileDrawer}>
              <p className="text-highlight uppercase mx-2.5">
                {category.category.toLowerCase()}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default CasinoDrawerTabs
